// import React from 'react';
// import './PracticeDetails.css';

// const PracticeDetails = ({ practiceData }) => {
//   if (!practiceData) {
//     return (
//       <div className="practice-details-alert practice-details-alert-info" role="alert">
//         No practice data available.
//       </div>
//     );
//   }

//   // Get status badge class based on status
//   const getStatusBadgeClass = (status) => {
//     if (!status || typeof status !== 'string') {
//       return 'practicetotal';
//     }
//     switch (status.toLowerCase()) {
//       case 'active':
//         return 'practiceactive';
//       case 'pending':
//         return 'practicepending';
//       case 'locked':
//         return 'practicelocked';
//       case 'inactive':
//         return 'practicelocked';
//       default:
//         return 'practicetotal';
//     }
//   };

//   return (
//     <div className="practice-details">
//       {/* Primary and Secondary Contact Section */}
//       <div className="practice-details-contact-section">
//         <div className="row">
//           {/* Primary Contact */}
//           <div className="col-md-6">
//             <div className="practice-details-contact-card">
//               <h5>Primary Contact</h5>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Facility</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.address_line_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Email</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.email_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 1</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 2</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Fax</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.fax_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">RPM Start Date</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   {practiceData.rpm_start_date ? 
//                     new Date(practiceData.rpm_start_date).toLocaleDateString('en-US', {
//                       month: '2-digit',
//                       day: '2-digit',
//                       year: 'numeric'
//                     }) : 'N/A'}
//                 </span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">RPM End Date</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   {practiceData.rpm_end_date ? 
//                     new Date(practiceData.rpm_end_date).toLocaleDateString('en-US', {
//                       month: '2-digit',
//                       day: '2-digit',
//                       year: 'numeric'
//                     }) : 'N/A'}
//                 </span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Status</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">
//                   <span className={`status-badge ${getStatusBadgeClass(practiceData.status)}`}>
//                     {practiceData.status || 'N/A'}
//                   </span>
//                 </span>
//               </div>
//             </div>
//           </div>

//           {/* Secondary Contact */}
//           <div className="col-md-6">
//             <div className="practice-details-contact-card">
//               <h5>Secondary Contact</h5>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Facility</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.address_line_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Email</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.email_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 1</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_2 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Phone 2</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.phone_1 || 'N/A'}</span>
//               </div>

//               <div className="practice-details-info-row">
//                 <span className="practice-details-info-label">Fax</span>
//                 <span className="practice-details-info-separator">:</span>
//                 <span className="practice-details-info-value">{practiceData.fax_1 || 'N/A'}</span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Monitoring Details Section */}
//       <div className="practice-details-monitoring-section">
//         <div className="practice-details-monitoring-card">
//           <h5>Monitoring Details</h5>

//           <div className="row">
//             <div className="col-md-6">
//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Do you want eVitals to Monitor your patients</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.monitor_to_patient ? 'Yes' : 'No'}
//                 </span>
//               </div>

//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Patients To Be Monitored</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   <span className="practice-details-monitoring-types">
//                     {practiceData.selected_monitoring_types && practiceData.selected_monitoring_types.length > 0 ? (
//                       practiceData.selected_monitoring_types.map((type, index) => {
//                         const typeNames = {
//                           1: 'Blood Pressure',
//                           2: 'Blood Glucose', 
//                           3: 'Weight'
//                         };
//                         return (
//                           <span key={index} className="practice-details-monitoring-type-badge">
//                             {typeNames[type] || `Type ${type}`}
//                           </span>
//                         );
//                       })
//                     ) : 'N/A'}
//                   </span>
//                 </span>
//               </div>
//             </div>

//             <div className="col-md-6">
//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Buying Device</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.buying_listing_device ? 'Yes' : 'No'}
//                 </span>
//               </div>

//               <div className="practice-details-monitoring-row">
//                 <span className="practice-details-monitoring-question">Leasing Device</span>
//                 <span className="practice-details-monitoring-answer">
//                   <span className="practice-details-info-separator">:</span>
//                   {practiceData.leasing_listing_device ? 'Yes' : 'No'}
//                 </span>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default PracticeDetails;
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList } from '@fortawesome/free-solid-svg-icons';
import '../PracticesList/AddPractice/AddPractice.css';
import '../AdminManagement/AdminManagement.css';
import './PracticeDetails.css';
import { formatPhoneForDisplay } from '../../../utils/phoneUtils';
import { formatDateOnlyUs } from '../../../utils/dateOnlyUtils';
import { isEvitalsMonitoringPractice } from '../../../utils/practiceMonitoringUtils';
import { appendFromDashboardQuery } from '../../../utils/practiceNavigation';

const PracticeDetails = ({
  practiceData,
  embeddedInPracticeDashboard = false,
  practiceId = null,
  onOpenEventLogs = null,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  if (!practiceData) {
    return (
      <div className="practice-details-alert practice-details-alert-info" role="alert">
        No practice data available.
      </div>
    );
  }

  // Get status color based on status
  const getStatusColor = (status) => {
    const normalized = String(status ?? '').trim().toLowerCase();
    if (normalized === 'active' || normalized === '2' || normalized === 'a') {
      return '#28a745';
    }
    if (normalized === 'pending' || normalized === '3' || normalized === 'p') {
      return '#e08102';
    }
    if (
      normalized === 'locked' ||
      normalized === 'lock' ||
      normalized === '4' ||
      normalized === 'l'
    ) {
      return '#dc3545';
    }
    if (normalized === 'inactive' || normalized === '1' || normalized === 'i') {
      return '#dc3545';
    }
    return 'inherit';
  };

  // Get logo URL - construct full URL if logo path exists
  const getLogoUrl = () => {
    if (!practiceData.practice_logo) return null;

    // If it's already a full URL, return it
    if (practiceData.practice_logo.startsWith('http://') || practiceData.practice_logo.startsWith('https://')) {
      return practiceData.practice_logo;
    }

    // Otherwise, construct URL from backend
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3000';
    // Remove /api if present in API_URL
    const baseUrl = API_URL.replace('/api', '');
    // Ensure logo path starts with /
    const logoPath = practiceData.practice_logo.startsWith('/')
      ? practiceData.practice_logo
      : `/${practiceData.practice_logo}`;

    return `${baseUrl}${logoPath}`;
  };

  const formatPracticeDate = (value) => {
    if (!value) return 'N/A';
    return formatDateOnlyUs(value) || 'N/A';
  };

  const getInitials = (name) => {
    if (!name) return '';
    const parts = name.trim().split(' ').filter(Boolean);
    if (parts.length === 0) return '';
    if (parts.length === 1) return parts[0].substring(0, 2).toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
  };

  const calculateDuration = (start, end) => {
    if (!start || !end) return '-';
    // Parse YYYY-MM-DD directly (local date, not UTC) to avoid 1-day shift in negative TZ offsets
    const parseLocal = (val) => {
      const m = String(val).trim().match(/^(\d{4})-(\d{2})-(\d{2})/);
      if (m) return new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]));
      return new Date(val);
    };
    const sDate = parseLocal(start);
    const eDate = parseLocal(end);
    if (Number.isNaN(sDate.getTime()) || Number.isNaN(eDate.getTime())) return '-';
    const diffTime = Math.abs(eDate - sDate);
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24)) + 1;
    return diffDays > 0 ? diffDays : '-';
  };

  const programDateEntries = (Array.isArray(practiceData.enrolled_programs) ? practiceData.enrolled_programs : [])
    .map((program) => {
      if (!program) return null;
      const name = typeof program === 'string'
        ? program
        : program.short_name || program.full_name || program.label || program.id || program.program || '';
      const startDate = typeof program === 'string'
        ? null
        : program.start_date || program.rpm_start_date || program.startDate || null;
      const endDate = typeof program === 'string'
        ? null
        : program.end_date || program.rpm_end_date || program.endDate || null;
      if (!name || (!startDate && !endDate)) return null;
      return { name, startDate, endDate };
    })
    .filter(Boolean);

  const isRpmEnrolled = (Array.isArray(practiceData.enrolled_programs) ? practiceData.enrolled_programs : [])
    .some((program) => String(program?.short_name || program?.id || '').trim().toUpperCase() === 'RPM');

  const logoUrl = getLogoUrl();
  const primaryAddress = practiceData.primary_address || {};
  const secondaryAddress = practiceData.secondary_address || {};

  const primaryFacility = practiceData.address_line_1 || primaryAddress.address_line_1 || 'N/A';
  const primaryEmail = practiceData.email_1 || primaryAddress.email || 'N/A';
  const primaryPhone1 = formatPhoneForDisplay(practiceData.phone_1 || primaryAddress.phone, 'N/A');
  const primaryPhone2 = formatPhoneForDisplay(practiceData.phone_2 || primaryAddress.cell_phone, 'N/A');
  const primaryFax = formatPhoneForDisplay(practiceData.fax_1 || primaryAddress.fax, 'N/A');

  const primaryContactCard = (
    <div className="add-practice-section-card practice-details-add-section flex-fill">
      <h5 className="add-practice-section-header">Primary Contact</h5>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Facility</span>
        <span className="practice-details-info-separator">:</span>
        <span className="practice-details-info-value">{primaryFacility}</span>
      </div>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Email</span>
        <span className="practice-details-info-separator">:</span>
        <span className="practice-details-info-value">{primaryEmail}</span>
      </div>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Phone 1</span>
        <span className="practice-details-info-separator">:</span>
        <span className="practice-details-info-value">{primaryPhone1}</span>
      </div>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Phone 2</span>
        <span className="practice-details-info-separator">:</span>
        <span className="practice-details-info-value">{primaryPhone2}</span>
      </div>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Fax</span>
        <span className="practice-details-info-separator">:</span>
        <span className="practice-details-info-value">{primaryFax}</span>
      </div>

      <div className="practice-details-info-row">
        <span className="practice-details-info-label">Status</span>
        <span className="practice-details-info-separator">:</span>
        <span
          className="practice-details-info-value"
          style={{
            color: getStatusColor(practiceData.status),
            fontWeight: '600'
          }}
        >
          {practiceData.status || 'N/A'}
        </span>
      </div>

      {programDateEntries.length > 0 && (
        <div className="practice-details-info-row">
          <span className="practice-details-info-label">Program Dates</span>
          <span className="practice-details-info-separator">:</span>
          <span className="practice-details-info-value practice-details-program-table-host">
            <div className="practice-details-program-table-wrap">
              <table className="practice-details-program-table">
                <thead>
                  <tr>
                    <th>Program</th>
                    <th>Start date</th>
                    <th>End date</th>
                    <th>Days</th>
                  </tr>
                </thead>
                <tbody>
                  {programDateEntries.map((entry, index) => (
                    <tr key={`${entry.name}-${index}`}>
                      <td>
                        <div className="program-avatar-container">
                          <div className="program-name">{entry.name}</div>
                        </div>
                      </td>
                      <td>{formatPracticeDate(entry.startDate)}</td>
                      <td>{formatPracticeDate(entry.endDate)}</td>
                      <td>{calculateDuration(entry.startDate, entry.endDate)}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </span>
        </div>
      )}
    </div>
  );

  return (
    <div className={`practice-details${embeddedInPracticeDashboard ? ' practice-details--embedded' : ''}`}>
      <div className="practice-details-contact-section">
        {embeddedInPracticeDashboard ? (
          <div className="practice-details-primary-slot">{primaryContactCard}</div>
        ) : (
          <div className="row mt-0 g-0">
            <div className="col-12 d-flex">{primaryContactCard}</div>
          </div>
        )}
      </div>

      {/* Monitoring Details Section */}
      <div className="practice-details-monitoring-section">
        <div className="add-practice-section-card practice-details-add-section practice-details-add-section--wide">
          <h5 className="add-practice-section-header">Monitoring Details</h5>

          <div className="row">
            <div className="col-md-6">
              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">eVitals Monitoring</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {isEvitalsMonitoringPractice(practiceData)
                    ? 'Yes - eVitals monitoring'
                    : 'No - Self monitoring'}
                </span>
              </div>

              <div className="practice-details-monitoring-row practice-details-monitoring-row--inline-types">
                <span className="practice-details-monitoring-question">Patients To Be Monitored</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  <span className="practice-details-monitoring-types">
                    {practiceData.selected_monitoring_types && practiceData.selected_monitoring_types.length > 0 ? (
                      practiceData.selected_monitoring_types.map((type, index) => {
                        const typeNames = {
                          1: 'Blood Pressure',
                          2: 'Blood Glucose',
                          3: 'Weight'
                        };
                        return (
                          <span key={index} className="practice-details-monitoring-type-badge">
                            {typeNames[type] || `Type ${type}`}
                          </span>
                        );
                      })
                    ) : 'N/A'}
                  </span>
                </span>
              </div>
            </div>

            <div className="col-md-6">
              {isRpmEnrolled && (
                <>
              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">Buying Device</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {practiceData.buying_listing_device ? 'Yes' : 'No'}
                </span>
              </div>

              <div className="practice-details-monitoring-row">
                <span className="practice-details-monitoring-question">Leasing Device</span>
                <span className="practice-details-monitoring-answer">
                  <span className="practice-details-info-separator">:</span>
                  {practiceData.leasing_listing_device ? 'Yes' : 'No'}
                </span>
              </div>
                </>
              )}
            </div>
          </div>
        </div>
        <div className="practice-details-events-log-row">
          <button
            type="button"
            className="admin-management-events-log-btn"
            onClick={() => {
              if (typeof onOpenEventLogs === 'function') {
                onOpenEventLogs();
                return;
              }
              const id = practiceId || practiceData?.id;
              if (id) {
                navigate(
                  appendFromDashboardQuery(`/event-logs/Practice/all?practiceId=${id}`, location)
                );
              }
            }}
          >
            <FontAwesomeIcon icon={faList} className="admin-management-add-icon" />
            Event Logs
          </button>
        </div>
      </div>
    </div>
  );
};

export default PracticeDetails;